import React from 'react'
import PropTypes from 'prop-types'

import Input from 'components/Input'

import noop from 'lodash/noop'
import './style.scss'

const _renderErrors = (errors) => {
  const _renderError = (error, idx) => <li key={idx}>{error}</li>
  const hasErrors =  errors.length > 0

  return hasErrors ? (
    <ul className="errors-list">
      {errors.map(_renderError)}
    </ul>
  ) : null
}


export default function TimeInput(props) {

  const _onTimeChanged = (timeObject) => {
    let time = timeObject.target.value
    // TODO: validate format for time
    // try {
    //   time = timeObject.format(props.format)
    // } catch(e) {}

    var patt = new RegExp("^([0-9]|0[0-9]|1[0-9]|2[0-3]):[0-5][0-9]$");
    var validDate = patt.test(time);
    validDate = validDate || time === ""

    var errors = []
    if (!validDate){
      errors = ["Hora no válida, se requiere HH:MM"]
    }

    // so we simulate normal operation with evt.target
    // this will avoid to replicate this validation and date parsing every time
    // we want to have date as string.
    // at the time we don't need the Date Object received here, but
    // just in case, we can access it on the same callback
    props.onChange({
      time: timeObject,
      target: {
        name: props.name,
        value: time,
        isValid: validDate,
        errors: errors
      }  
    })
  }


  const Label = !!props.label ? ( <label>{props.label}</label> ) : null
  const errorClass = props.errors.length ? 'has-error' : ''
  return (
    <div className={`TimeInput ${errorClass}`}>
      {Label}
      <div className={`TimeInput__wrapper ${errorClass}`}>
        <div className="TimeInput__wrapper__icon">
          <i className="material-icons">access_time</i>
        </div>
        <Input
          format={props.format}
          name={props.name}
          onChange={_onTimeChanged}
          placeholder={props.format}
          type="text"
          value={props.value}
          readOnly={false}
        />
      </div>
      {_renderErrors(props.errors)}
    </div>
  )
}

TimeInput.defaultProps = {
  errors: [],
  format: 'HH:MM',
  name: '',
  onChange: noop,
  value: '',
  isValid: false,
}

TimeInput.propTypes = {
  errors: PropTypes.array,
  format: PropTypes.string,
  label: PropTypes.string,
  name: PropTypes.string,
  onChange: PropTypes.func,
  value: PropTypes.any,
}



// WEBPACK FOOTER //
// ./src/components/TimeInput/index.js